import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Lookup } from '../../models/lookup';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-select-has-search',
  standalone: false,
  templateUrl: './select-has-search.component.html'
})
export class SelectHasSearchComponent implements OnInit, OnChanges {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  searchControl = new FormControl('');
  @Input() key = 'userId';
  @Input() titleKey = 'name';
  @Input({ required: true }) searchTitle: string;
  @Input({ required: true }) titleField: string;
  @Input() errorMessage: string = '';
  @Input({ required: true }) controlName: string;
  @Input({ required: true }) formGroupBuilder: FormGroup | any;
  @Input({ required: true }) recordsData: any[] = [];
  @Input({ required: true }) dataLoading: boolean;
  @Input() required: boolean = false;
  @Input() hasImage: boolean = true;
  @Input() valueKey: boolean = false;
  @Input() disabled: boolean = false;
  @Input() selectAll: boolean = false;
  @Input() multiple = false;
  @Input() maxSelection: number | null = null;
  @Output() selectionChanged = new EventEmitter<boolean>();
  filteredData: any[] = [];
  selectedRecord: any;

  constructor() { }

  ngOnInit() {
    this.searchControl.valueChanges.subscribe(value => {
      this.filterRecords(value || '');
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['recordsData'] && changes['recordsData'].currentValue) {
      this.filteredData = this.recordsData;
      // console.log(this.recordsData)
    }
    this.updateDisabledState();
  }

  get selectedItems(): any[] {
    const value = this.formGroupBuilder.get(this.controlName)?.value ?? [];

    return this.valueKey
      ? this.recordsData.filter(item => value.includes(item[this.key]))
      : value;
  }

  getSelectedTitle(): string {
    const value = this.formGroupBuilder?.get(this.controlName)?.value;

    if (value == null) {
      return '';
    }

    const record = this.valueKey
      ? this.recordsData?.find(item => item[this.key] === value)
      : value;

    return record?.[this.titleKey] ?? '';
  }

  removeItem(index: number): void {
    // debugger
    const items = [...this.selectedItems];
    items.splice(index, 1);
    this.formGroupBuilder.controls[this.controlName].setValue(items);
  }

  filterRecords(searchWord: string) {
    this.filteredData = this.recordsData.filter(item =>
      item[this.titleKey].toLowerCase().includes(searchWord.toLowerCase())
    );
  }

  onSelectionChange(event: MatSelectChange): void {
    // console.log(event.value)
    // this.clearSearch();
    this.selectedRecord = event.value;
    this.selectionChanged.emit(true);
  }

  onOpenedChange(opened: boolean): void {
    if (opened) {
      setTimeout(() => { this.searchInput?.nativeElement.focus(); });
    } else {
      this.clearSearch();
    }
  }

  toggleSelectAll(checked: boolean) {
    if (checked) {
      let allIds = this.filteredData.map(item => item);
      if (this.multiple) {
        const currentValue = this.formGroupBuilder.get(this.controlName)?.value ?? [];
        currentValue.forEach(item => {
          if (!allIds.includes(this.valueKey ? item[this.key] : item)) {
            allIds.push(item);
          }
        });
      }
      this.formGroupBuilder.get(this.controlName)?.setValue(allIds);
    } else {
      this.formGroupBuilder.get(this.controlName)?.setValue([]);
    }
  }

  isAllSelected(): boolean {
    const selectedValues = this.formGroupBuilder.get(this.controlName)?.value || [];
    if (this.filteredData.length === 0) return false;
    return this.filteredData.every(item => selectedValues.includes(this.valueKey ? item[this.key] : item));
  }

  isIndeterminate(): boolean {
    const selectedValues = this.formGroupBuilder.get(this.controlName)?.value || [];
    if (this.filteredData.length === 0) return false;
    const selected = Array.isArray(selectedValues)
      ? selectedValues
      : [selectedValues];

    const selectedCount = this.filteredData.filter(item => {
      const value = this.valueKey ? item[this.key] : item;
      return selected.includes(value);
    }).length;

    return selectedCount > 0 && selectedCount < this.filteredData.length;
  }

  clearSearch(event?: MouseEvent): void {
    event?.stopPropagation();
    this.searchControl.setValue('', { emitEvent: true });
    this.filteredData = [...this.recordsData];
  }

  isItemFiltered(item: Lookup): boolean {
    return this.filteredData.includes(item);
  }

  isOptionDisabled(item: any): boolean {
    // No maximum configured
    if (!this.multiple || !this.maxSelection) {
      return false;
    }

    const selectedValues = this.formGroupBuilder
      .get(this.controlName)
      ?.value ?? [];

    const value = this.valueKey ? item[this.key] : item;

    // Keep already selected items enabled
    if (selectedValues.includes(value)) {
      return false;
    }

    // Disable new items when maximum is reached
    return selectedValues.length >= this.maxSelection;
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroupBuilder?.controls[controlName].hasError(errorName);
  }

  private updateDisabledState(): void {
    const control = this.formGroupBuilder.get(this.controlName);

    if (!control) return;

    if (this.dataLoading || this.disabled) {
      control.disable({ emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
    }
  }
}
